const setGstr1ActiveTab = (state, activeTab) => {
  state.activeTab = activeTab;
};

export default {
  setGstr1ActiveTab
};
